var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"iframeBox"},[_c('iframe',{attrs:{"src":"http://192.168.2.3:7860/?__theme=dark","frameborder":"0"}})])
}]

export { render, staticRenderFns }